import { useT } from "../i18n/index.js";
import { ShopsView } from "../store/ShopsView.js";

/** Shop tab (D72): the alliance shop through the store's shop view, coins from donations, tiers from the Trade Hub. */
export function AllianceShop() {
  const t = useT();
  return (
    <div className="alliance-shop" data-testid="alliance-shop">
      <p className="hint" style={{ margin: "0 12px 8px" }}>{t("alliance.shop.hint")}</p>
      <ShopsView only="shop.alliance" />
    </div>
  );
}
